import { render, staticRenderFns } from "./specific-list.vue?vue&type=template&id=191b4e39&scoped=true&"
import script from "./specific-list.vue?vue&type=script&lang=js&"
export * from "./specific-list.vue?vue&type=script&lang=js&"
import style0 from "./specific-list.vue?vue&type=style&index=0&id=191b4e39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b4e39",
  null
  
)

export default component.exports